export default __webpack_public_path__ + "static/bg_pattern-81644057a3d6c6de353cbf0b99ccaf22.png";